import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import {
  parseViewingTagSelection,
  serializeViewingTagSelection,
  type ViewingTagSelection,
} from '@/utils/viewingTagSelection';
import {
  readViewingTagSelectedSession,
  writeViewingTagSelectedSession,
} from '@/utils/viewingTagSession';

function readSelectedFromSession(): ViewingTagSelection {
  if (typeof window === 'undefined') {
    return null;
  }
  return parseViewingTagSelection(readViewingTagSelectedSession());
}

function writeSelectedToSession(selection: ViewingTagSelection): void {
  if (typeof window === 'undefined') {
    return;
  }
  writeViewingTagSelectedSession(
    selection === null ? null : serializeViewingTagSelection(selection),
  );
}

export interface ViewingTagState {
  selectedViewingTag: ViewingTagSelection;
  defaultViewingTag: ViewingTagSelection;
}

const initialState: ViewingTagState = {
  selectedViewingTag: readSelectedFromSession(),
  defaultViewingTag: null,
};

const viewingTagSlice = createSlice({
  name: 'viewingTag',
  initialState,
  reducers: {
    setSelectedViewingTag(state, action: PayloadAction<ViewingTagSelection>) {
      state.selectedViewingTag = action.payload;
      writeSelectedToSession(action.payload);
    },
    setDefaultViewingTag(state, action: PayloadAction<ViewingTagSelection>) {
      state.defaultViewingTag = action.payload;
    },
    applyDefaultAsSelected(state) {
      if (
        state.selectedViewingTag === null &&
        state.defaultViewingTag !== null
      ) {
        state.selectedViewingTag = state.defaultViewingTag;
        writeSelectedToSession(state.defaultViewingTag);
      }
    },
  },
});

export const {
  setSelectedViewingTag,
  setDefaultViewingTag,
  applyDefaultAsSelected,
} = viewingTagSlice.actions;

export default viewingTagSlice.reducer;
